import { render } from "./TicketsHeader.vue?vue&type=template&id=63c0cc92"
import script from "./TicketsHeader.vue?vue&type=script&lang=js"
export * from "./TicketsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__